import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../hooks/useSeo';
import { useTranslation } from '../contexts/LanguageContext';
import '../App.css';
import './NotFoundPage.css';

const NotFoundPage = ({ loggedIn = false }) => {
  const { t } = useTranslation();

  useSeo({
    title: t('notFound.seoTitle'),
    description: t('notFound.seoDescription'),
    canonical: 'https://statarena.app/404',
    robots: 'noindex, follow',
    ogUrl: 'https://statarena.app/404',
  });

  return (
    <main className="not-found-page">
      <section className="not-found-hero">
        <span className="not-found-code">404</span>
        <h1>{t('notFound.title')}</h1>
        <p>
          {t('notFound.body')}
        </p>
        <div className="not-found-actions">
          <Link to={loggedIn ? '/' : '/'} className="btn btn-primary btn-lg">
            {t('notFound.home')}
          </Link>
          <Link to="/directory" className="btn btn-secondary btn-lg">
            {t('notFound.viewTeams')}
          </Link>
          <Link to="/generator-timova" className="btn btn-secondary btn-lg">
            {t('notFound.teamGenerator')}
          </Link>
        </div>
      </section>

      <section className="not-found-links" aria-label={t('notFound.usefulLinks')}>
        <Link to="/raspored-turnira">{t('notFound.tournamentSchedule')}</Link>
        <Link to="/semafor-online">{t('notFound.scoreboard')}</Link>
        {!loggedIn && <Link to="/login">{t('nav.login')}</Link>}
      </section>
    </main>
  );
};

export default NotFoundPage;
